import { MediaMatcher } from '@angular/cdk/layout';
import {
    AfterViewInit, ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit, ViewChild
} from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { AccountDebtorService } from '../../../services/accountDebtor.service';
import { NavigationService } from '../../../services/navigation.service';
import { SnackBarService } from '../../../services/snack.bar.service';
import { routerTransition } from '../../shared/animations';
import { BottomSheet } from '../../shared/dialog/bottomSheet/bottom-sheet';
import { MenuItems } from '../../shared/menu-items/menu-items';
import { SharedService } from './../../../services/shared.service';
import $ from 'jquery';



@UntilDestroy()
@Component({
    selector: 'app-full-layout',
    templateUrl: 'full.component.html',
    styleUrls: ['./full.component.scss'],
    providers: [MatBottomSheet],
    animations: [routerTransition]
})
export class FullComponent implements OnDestroy, AfterViewInit, OnInit {

    @ViewChild('snav', { static: true }) public snav: MatSidenav;

    mobileQuery: MediaQueryList;
    minisidebar: boolean;
    showHide: boolean;
    sidebarOpened;

    public config: PerfectScrollbarConfigInterface = {};
    private _mobileQueryListener: () => void;

    constructor(
        private navigationService: NavigationService,
        private bottomSheet: MatBottomSheet,
        changeDetectorRef: ChangeDetectorRef,
        media: MediaMatcher,
        public menuItems: MenuItems,
        public dialog: MatDialog,
        public sharedService: SharedService,
        private snackBarService: SnackBarService,
        private accountDebtorService: AccountDebtorService

    ) {
        this.mobileQuery = media.matchMedia('(min-width: 768px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        this.mobileQuery.addListener(this._mobileQueryListener);
    }

    getState(outlet: RouterOutlet) {
        return outlet.activatedRouteData?.rState;
    }


    openBS() {
        event.stopPropagation();
        const a = this.bottomSheet.open(BottomSheet, { data: 1 });
        a.afterDismissed().pipe(untilDestroyed(this)).subscribe((x) => {
        });
    }

    ngOnInit() {
        this.sharedService.sideNav = this.snav;
        this.accountDebtorService.initAccountDebtor();
    }

    ngOnDestroy(): void {
        this.mobileQuery.removeListener(this._mobileQueryListener);
    }

    ngAfterViewInit() {
    }

    dialogs() {
        this.snackBarService.show('haha', 'Undo');
        this.snackBarService.show('haha');
        // this.snackBarService.show("sohai");
        /* var a =  this.bottomSheet.open(BottomSheet,{data:1});
        a.afterDismissed().pipe(untilDestroyed(this)).subscribe((x)=>{
        }); */
        /* const dialogRef = this.dialog.open(ConfirmationDialog, {
          width: '250px',
          data : {showTextBox:true}
        });

        dialogRef.afterClosed().pipe(untilDestroyed(this)).subscribe(result => {
        }); */
    }
}
